import {Link} from 'react-router-dom';
import React from 'react';

import {useracc, postApi, putApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';

import FormControl from 'react-bootstrap/FormControl';

export default class AccountRegister extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: -1,
			process: false,
			general: {
				error: '',
			},

			
			username: {
				text: '',
				valid: false,
				error: '',
			},
			password: {
				text: '',
				valid: false,
				error: '',
				visible: false,
			},
			email: {
				text: '',
				valid: false,
				error: '',
			},
			cookies: navigator.cookieEnabled
		};
		this.handleChange = this.handleChange.bind(this);
		this.showPassword = this.showPassword.bind(this);
		this.processRegister = this.processRegister.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		if( window.location.pathname.search(/register\//i) >= 0 ) {
			//---- Found a key and try to enter it
			let code = window.location.pathname.replace('/register/','');
			var params2 = new URLSearchParams();
			params2.append('code', code);
			//const x = 
			await putApi('/v3/account/register/verify', params2);
			window.location.href = '/';
		}

		let params = new URLSearchParams();
		const x = await postApi('/v3/account/register', params);
		let email = this.state.email;
		email.text = x.data.email;
		
		if( x.data.email.length > 0 ) {
			this.setState({status: x.data.status, email});
		} else {
			this.setState({status: x.data.status});
		}
	}

	componentWillUnmount() {
	}


	handleChange(event) {
		var item = event.target.value;
		if( event.target.name === "username" ) {
			let username = this.state.username;
			const word = /^[A-Z0-9_]*$/i;
			username.text = item.replaceAll(" ","");
			username.valid = true;
      if( word.test(String(item)) ) this.setState({username});
		}
		if( event.target.name === "email" ) {
			const res = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			let email = this.state.email;
			email.text = item.toLowerCase();
			email.valid = res.test(String(item));
			if( !email.valid ) {
				email.error = 'Please enter a valid email address';
			} else {
				email.error = '';
			}
      this.setState({email});
		}
		if( event.target.name === "password" ) {
			const decimal = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,40}$/;
			let password = this.state.password;
			password.text = item;
			password.valid = decimal.test(String(item));
			if( !password.valid ) {
				password.error = 'Requires a Capital, Number and a Special character';
			} else {
				password.error = ''
			}
			if(item.length < 8 || item.length > 40 ) {
				password.valid = false;
				password.error = 'Requires 8 to 40 characters';
			}
      this.setState({password});
		}
	}

	showPassword() {
		let password = this.state.password;
		password.visible = !password.visible;
		this.setState({password});
	}
	

	async processRegister(event) {
		event.preventDefault();
		this.setState({process: true}, async () => {
			await this.processRegister2(event);
			this.setState({process: false});
		});
	}
	async processRegister2(event) {
		event.preventDefault();
	

		const params = new URLSearchParams();
		params.append('username', this.state.username.text);
		params.append('email', this.state.email.text);
		params.append('password', this.state.password.text);
		//params.append('passwordrpt', this.state.passwordrpt);

		const x = await putApi('/v3/account/register', params);
		if( x.status !== 200 ) {
			switch( x.status ) {
				case 210:
					break;
				case 3:
					break;
				case 210:
					this.setState({general: {error: x.data.message}});
					break;
				case 211: //---- Username errors
					let username = this.state.username;
					username.error = x.data.message
					username.valid = false;
					this.setState({username});
					break;
				case 212: case 213: case 218: // ---- Email errors
					let email = this.state.email;
					email.error = x.data.message
					email.valid = false;
					this.setState({email});
					break;
				case 215: //---- email allready registered
					let password = this.state.password;
					password.error = x.data.message
					password.valid = false;
					this.setState({password});
					break;
				default:
					break;
			}
			return;
		} else {
			let cookies = document.cookie.split(';');
			cookies = cookies.map(cookie => cookie.split("="));
			for( let i in cookies ) {
				if( cookies[i][0] === 'returnFixed' ) {
					window.location.href = cookies[i][1];
					return;
				}
				if( cookies[i][0] === 'order' ) {
					window.location.href = '/cart';
					return;
				}
			}
			window.location.href = '/';
		}
	}

	render() {
		
		return (
			<>
				<div className="container">
					<div className="row justify-content-center ">
						<div className="col-xl-8 col-md-12 col-sm-10 ">
							<div className="card custom-card  rectangle2">
								<div className="card-body p-0 ">
									<div className="row">
										<div className="col-xl-6 col-md-6 pe-sm-0 d-flex">
											<form onSubmit={this.processRegister}>
												<div className="p-5">
													<p className="h4 fw-semibold mb-2">Sign Up</p>
													<p className="mb-3 text-muted op-7 fw-normal">Create your account by filling in the details below.</p>
													{this.state.general.error.length > 0 &&
														<p className="text-secondary fw-semibold">Error: {this.state.general.error}</p>
													}
													<div className="row gy-3 mt-3">
														<div className="col-xl-12 mt-0">
															<label htmlFor="username" className="form-label text-default">Username
																{this.state.username.valid===true&&this.state.username.text.length>0&&<>&nbsp;<span className="badge rounded-pill bg-success-gradient p-1"><FontAwesomeIcon icon="check" style={{color: '#ffffff'}} /></span></>}
															</label>
															{this.state.username.valid === false && this.state.username.text.length > 0 &&
																<label htmlFor="username" className="form-label text-secondary fw-semibold">&nbsp;* {this.state.username.error}</label>
															}
															<FormControl name="username" id="username" onChange={this.handleChange} value={this.state.username.text} placeholder="Username" aria-label="Username" aria-describedby="Username" required />
														</div>
														<div className="col-xl-12">
															<label htmlFor="email" className="form-label text-default">Email Address
																{this.state.email.valid===true&&this.state.email.text.length>0&&<>&nbsp;<span className="badge rounded-pill bg-success-gradient p-1"><FontAwesomeIcon icon="check" style={{color: '#ffffff'}} /></span></>}
															</label>
															{this.state.email.valid === false && this.state.email.text.length > 0 &&
																<label htmlFor="email" className="form-label text-secondary fw-semibold">&nbsp;* {this.state.email.error}</label>
															}
															<FormControl name="email" id="email" onChange={this.handleChange} value={this.state.email.text} placeholder="Email Address" aria-label="Email Address" aria-describedby="Email Address" required />
														</div>
														<div className="col-xl-12 mb-3">
															<label htmlFor="signin-password" className="form-label text-default d-block">Password 
																{this.state.password.valid===true&&this.state.password.text.length>0&&<>&nbsp;<span className="badge rounded-pill bg-success-gradient p-1"><FontAwesomeIcon icon="check" style={{color: '#ffffff'}} /></span></>}
															</label>
															{this.state.password.valid === false && this.state.password.text.length > 0 &&
																<label htmlFor="password" className="form-label text-secondary fw-semibold">&nbsp;* {this.state.password.error}</label>
															}
															<div className="input-group">
																<FormControl type={this.state.password.visible?'text':'password'} name="password" id="password" onChange={this.handleChange} value={this.state.password.text} placeholder="Password" aria-label="Password" aria-describedby="Password" required />
																<button className="btn btn-light bg-transparent" type="button" onClick={this.showPassword} id="button-addon2"><FontAwesomeIcon icon={this.state.password.visible===true?'eye':'eye-slash'} /> <i className="ri-eye-off-line align-middle"></i></button>
															</div>
														</div>
														<div className="col-xl-12 d-grid mt-2">
															<button className="btn btn-lg btn-primary mt-4">Create Account</button>
														</div>
													</div>
													<div className="text-center">
														<p className="fs-12 text-muted mt-3">Already have an account? <Link to="/" className="text-primary">Sign In</Link></p>
													</div>
												</div>
											</form>
										</div>
										<div className="col-xl-6 col-md-6 ps-0 text-fixed-white rounded-0 d-none d-md-block  ">
											<div className="card custom-card mb-0 cover-background overflow-hidden rounded-end rounded-0">
												<div className="card-img-overlay d-flex  align-items-center p-0 rounded-0">
													<div className="card-body p-5 rectangle3">
														<div>
															<a href="https://ultrastream.io"> <img src={`https://cloud.ultrastream.io/images/logo-us-large.png?d=${Math.floor(Date.now()/1000)}`} alt="logo" className="toggle-logo" width={"100%"} /></a>
														</div>
														<h6 className="mt-4 fs-15 op-9  text-fixed-white">Sign In</h6>
														<div className="d-flex mt-3">
															<p className="mb-0 fw-normal fs-14 op-7  text-fixed-white">Get started today by registering for an Account with Ultrastream.io.</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

